import React from 'react';

const artworkByService = {
  cryptoPage: 'cryptocurrency',
  forexPage: 'forex',
  binaryPage: 'binary-options',
  stockPage: 'stock-trading',
  romancePage: 'romance',
  creditCardPage: 'credit-card-phishing',
  propertyPage: 'property',
  otherPage: 'other'
};

const ServiceArtwork = ({ translationPrefix }) => {
  const service = artworkByService[translationPrefix];
  if (!service) return null;

  const imagePath = `${process.env.PUBLIC_URL}/img/expertise/${service}`;
  return (
    <div className="tb-service-artwork" aria-hidden="true" data-service-art={service}>
      <img
        src={`${imagePath}-960.webp`}
        srcSet={`${imagePath}-480.webp 480w, ${imagePath}-960.webp 960w`}
        sizes="(max-width: 640px) calc(100vw - 40px), (max-width: 760px) calc(100vw - 96px), (max-width: 1000px) 34vw, 430px"
        width="960"
        height="640"
        alt=""
        decoding="async"
        fetchPriority="high"
      />
    </div>
  );
};

export default ServiceArtwork;
